import {
  SET_CURRENT_SLIDE_MODE,
  WINDOWED_MODE,
  EDIT_MODE,
} from '@/vuex/types'
import EventBus from '@/eventBus'
import Socket from '@/socket'
import store from '@/vuex/store'
import util from '@/util'

const MESSAGE_TYPES = {
  PRESENTATION: 'presentation',
  EXPORT_STATUS: 'export-status',
}

const ACTIONS = {
  NEXT_SLIDE: 'nextSlide',
  PRESENTING: 'presenting',
  PRIVATE_MODE: 'privateMode',
  UNIQUE_ACCESS_CODE: 'uniqueAccessCode',
  CHANGE_ACCESS_CODE: 'changeAccessCode',
  PRESENTATION_UPDATE: 'presentation-update',
  UPDATE_CANVAS_BLOCKS: 'update-canvas-blocks',
}

function nextSlideHandler(doc, editor) {
  if (store.state.isEnableAddinPowerpoint) {
    store.state.presentation.activeSlide = doc.data.id
    return
  }
  if (editor.sharePresentation ||
    editor.$store.state.isDisableEditPresentation) {
    return
  }

  if (!store.getters.isPresenting &&
    (store.state.presentation.accountId || store.state.presentation.hasSharedUser)) {
    return
  }

  if (doc.data.id == editor.slideActive.id) {
    return
  }

  const index = editor.presentation.slides.findIndex(
    (item) => {
      return item.id == doc.data.id
    },
  )
  editor.$store.dispatch('checkSlideMovingDirectionAction', doc.data.id)
  editor.$store.dispatch('updateSlideActive', {
    id: null,
  })
  setTimeout(() => {
    editor.$store.dispatch(
      'setSlideActive',
      editor.presentation.slides[index],
    )

    EventBus.$emit('eventHandleSetValueTransition')
  }, 0)
}

function presentingHandler(doc, editor) {
  if (editor.sharePresentation) {
    return
  }

  if (editor.$store.state.isPreview || doc.data.presentFromPPT) return
  const isMSTeamInParam = !!util.getParamValue(
    'ms-teams',
    window.location.href,
  )

  editor.$store.state.presentation.presenting = doc.data.presentation.presenting
  if (store.state.isEnableAddinPowerpoint) return

  // sửa thành tất cả các tabs present cùng nhau
  // để có thể khắc phục tình trạng 1 máy đang present
  // nhưng 1 tab khác edit thì màn hình đang present sẽ không được update
  // theo và nhảy lung tung mà don't know why.
  if (!editor.$store.state.isDisableEditPresentation) {
    if (doc.data.presentation.presenting) {
      editor.$store.dispatch(SET_CURRENT_SLIDE_MODE, WINDOWED_MODE)
    } else if (isMSTeamInParam) {
      // Khi đang edit bên AhaSlides tab thì cần alert user cần reload để lấy bản mới nhất cho bên MS Teams tab.
      // Do không phải cái gì cũng realtime update sang bên MS Teams tab.
      editor.isShowMSTeamsReloadModal = true
    } else {
      editor.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
    }
  }
}

function privateModeHandler(doc, editor) {
  editor.$store.state.presentation.privateMode = doc.data.presentation.privateMode
}

function uniqueAccessCodeHandler(doc, editor) {
  editor.$store.state.presentation.qrcode = doc.data.qrcode
  editor.$store.state.presentation.uniqueAccessCode = doc.data.uniqueAccessCode
  editor.$store.state.presentation.shareCode = doc.data.shareCode
}

function changeAccessCodeHandler(doc, editor) {
  editor.$store.state.presentation.accessCode = doc.data.accessCode
}

function presentationUpdateHandler(doc, editor) {
  if (doc.socketId === Socket.getSocketId()) {
    return
  }
  const newPayload = {}
  Object.keys(doc.data).forEach((key) => {
    const oldValue = doc.data[key]
    let newValue = oldValue
    if (typeof oldValue === 'string') {
      if (oldValue === 'true') {
        newValue = true
      }
      if (oldValue === 'false') {
        newValue = false
      }
    }
    newPayload[key] = newValue
  })
  editor.$store.dispatch('updatePresentation', newPayload)
}

function updateCanvasBlocksHandler(doc, editor) {
  if (doc.socketId === Socket.getSocketId()) {
    return
  }
  if (!doc.data || !doc.data.canvasBlocks) {
    return
  }
  editor.updateSlideByIdAction({
    id: doc.data.slideId,
    canvasBlocks: doc.data.canvasBlocks,
    canvasBlocksUrl: doc.data.canvasBlocksUrl,
  })
}

const actionHandlers = {
  [ACTIONS.NEXT_SLIDE]: nextSlideHandler,
  [ACTIONS.PRESENTING]: presentingHandler,
  [ACTIONS.PRIVATE_MODE]: privateModeHandler,
  [ACTIONS.UNIQUE_ACCESS_CODE]: uniqueAccessCodeHandler,
  [ACTIONS.CHANGE_ACCESS_CODE]: changeAccessCodeHandler,
  [ACTIONS.PRESENTATION_UPDATE]: presentationUpdateHandler,
  [ACTIONS.UPDATE_CANVAS_BLOCKS]: updateCanvasBlocksHandler,
}

function handleUpdatePresentation(doc, editor) {
  const { action } = doc
  if (action && actionHandlers[action]) {
    actionHandlers[action](doc, editor)
  }
}

function handleUpdateExportStatus(doc, editor) {
  editor.$store.dispatch('onlyPatchPresentationAction', { exportData: doc.exportData })

  const isExportImage = store.state.exportingType === 'image' && doc.exportData.status === 'success'
  const isExportPdf = store.state.exportingType === 'pdf' && doc.exportData.status === 'success'
  const isExportExcel = store.state.exportingType === 'excel' && doc.exportData.excelStatus === 'success'
  if (isExportImage) {
    util.downloadFile(doc.exportData.zipUrl)
    EventBus.$emit('export-image:success', doc.exportData)
    store.state.loadingExportImage = false
  }
  if (isExportPdf) {
    util.downloadFile(doc.exportData.pdfUrl)
    EventBus.$emit('export-pdf:success', doc.exportData)
    store.state.loadingExportPdfV2 = false
  }
  if (isExportExcel) {
    util.downloadFile(doc.exportData.excelUrl)
    EventBus.$emit('export-excel:success', doc.exportData)
    store.state.loadingExportExcelV2 = false
  }
  store.state.exportingType = null
}

const PresentationWebsocketSubscriber = {
  [MESSAGE_TYPES.PRESENTATION]: handleUpdatePresentation,
  [MESSAGE_TYPES.EXPORT_STATUS]: handleUpdateExportStatus,
}

export default PresentationWebsocketSubscriber
